import * as variables from './variables.js';

window.url_route    = variables.url_route;
window.url_api      = variables.url_api;
window.selector     = variables.selector;
window.today        = variables.today;
window.mm           = variables.mm;
window.dd           = variables.dd;
window.yyyy         = variables.yyyy;
window.currentDate  = (variables.mm < 10 ? '0' : '') + variables.mm + "/" + (variables.dd < 10 ? '0' : '') + variables.dd + "/" + variables.yyyy;

const _gnky = () => {

    return new Promise(resolve => {
        let settings = {
            "url":  url_api + "/gnky",
            "method": 'GET',
            "contentType": false,
            "processData": false,
            "headers": {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
            }
        };
        $.ajax(settings)
            .always(function (msg) {
                resolve(msg);
            });
    }).catch(error => { 

    });

}

const _method = (url, method, withKey, data) => {

    /* note : if GET method leave blank data data
    _method('route name', 'POST or GET', withKey, JSON.stringify({"data" : "data"})).then((response)=>{

    }).catch(error => { 
        
    });*/

    return new Promise(resolve => {
        
        let settings = {
            "url": url_api + url,
            "method": method,
            "contentType": false,
            "processData": false,
            "headers": {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content'),
                "Content-Type": "application/json",
                "Authorization": ""
            }
        }
        if(method == "POST"){
            settings.data = data;
        }
        if(withKey){
            _gnky().then((response) => {
                
                if(response.response != undefined && response.response.success != undefined){
                    _showMessage('warning', response.response.outMessage) 
                    return false;
                }
                
                settings.headers.Authorization = Buffer.from(response.token).toString('base64');
                
                $.ajax(settings)
                    .always(function (msg) {
                        resolve(msg);
                    });
            });
        }else{
            $.ajax(settings)
                .always(function (msg) {
                    resolve(msg);
                });
        }
        
    }).catch(error => { 
        _hideLoading();
    });

}

const _formGetDataNotIsset = (form_id) => {
    /* _formGetDataNotIsset('form id name'); */

    $('#' + form_id + ' .form-new-input-cr').remove();
    let divElemCreated = '<div class="form-new-input-cr d-none">';
    $('#' + form_id + ' input[type=checkbox]').each(function (){
        if($(this).attr('name') != undefined){
            divElemCreated += '<input type="hidden" name="' + $(this).attr('name') + '" value="' + ($(this).is(':checked') ? 'true' : 'false') + '">';
        }
    });

    let radioName = [];
    $('#' + form_id + ' input[type=radio]').each(function (){
        
        if($.inArray($(this).attr('name'), radioName) != -1){
            if($('#' + form_id + ' input[name="' + $(this).attr('name') + '"]:checked').val() == undefined){
                divElemCreated += '<input type="hidden" name="' + $(this).attr('name') + '" value="">';
            }else{
                divElemCreated += '<input type="hidden" name="' + $(this).attr('name') + '" value="' + $('#' + form_id + ' input[name="' + $(this).attr('name') + '"]:checked').val() + '">';
            }
        }else{
            radioName.push($(this).attr('name'));
        }
        
    });

    $('#' + form_id + ' input[type=text]:disabled').each(function (){
        divElemCreated += '<input type="hidden" name="' + $(this).attr('name') + '" value="' + $(this).val() + '">';
    });
    $('#' + form_id + ' textarea:disabled').each(function (){
        divElemCreated += '<input type="hidden" name="' + $(this).attr('name') + '" value="' + $(this).val() + '">';
    });
    divElemCreated += '</div>';
    $('#' + form_id).append(divElemCreated);
    setTimeout(function(){ $('#' + form_id + ' .form-new-input-cr').remove(); }, 2000);
}

const _formDataToJSON = (formData) => {
    /* 
    
    const   fData = new FormData($("#")[0]);
            fData.append('', '');
            fData.append('', '');

    const fDataFinal = _formDataToJSON(fData); */

    let ConvertedJSON = {};
    for (const [key, value] of formData.entries()) {
        ConvertedJSON[key] = value;
    }
    return JSON.stringify(ConvertedJSON);
}


const _showMessage = (icon, message) => {
    Swal.fire({
        showConfirmButton: false
    }).close();
    Swal.fire({
        icon: icon, /* info error success warning */
        html: message,
        focusConfirm: false,
        allowOutsideClick: false,
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show'
        },
        /* didOpen: function() {
            $('.swal2-modal, .swal2-html-container').css('background', 'white')
        }, */
        confirmButtonText: 'Okay'  
    });
}

const _showLoading = (message) => {
    Swal.fire({
        html: '<div class="fs-4 mt-2"><i class="fas fa-spinner fa-pulse text-white me-2"></i><label class="fs-5 text-white">' + (message == undefined || message == "" ? "Please wait..." : message) + "</label></div>",
        showConfirmButton: false,
        allowOutsideClick: false,
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show'
        },
        didOpen: function() {
            $('.swal2-modal, .swal2-html-container').css('background', 'transparent')
        }
    });
}

const _hideLoading = () => {
    Swal.fire({
        showConfirmButton: false
    }).close();
}


class _globalButtons {
    static home() {
        _method('/home', 'GET', true, '').then((response) => {
            window.location.href = response.response.url;
        }).catch(error => {     
        });  
    }

    static logout() {
        Swal.fire({
            html: "Are you sure you want to Sign-Out?",
            icon: 'question',
            focusConfirm: true,
            allowOutsideClick: false,
            showDenyButton: true,
            confirmButtonText: 'YES',
            denyButtonText: `NO `,
        }).then((result) => {
            if (result.isConfirmed) {
                _showLoading();
                _method('/logout', 'GET', true, '').then((response) => {
                    location.reload();
                }).catch(error => { 
                    location.reload();    
                });
            }
        })

    }

    static getEncodedPassword(){
        Swal.fire({
            title: 'Please enter a Password.',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            allowOutsideClick: false,
            preConfirm: (result) => {
                if(result == ""){
                    Swal.showValidationMessage(`Password is Empty"`)
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                _showLoading(); 
                _method('/get-encoded-string/' + result.value, 'GET', true, '').then((response) => {
                    _hideLoading();
                    
                    if(response.response.success){
                        
                        _showMessage('success', response.response.outMessage) 

                        return false;
                    }   
                    
                    _showMessage('warning', response.response.outMessage) 

                }).catch(error => { 
                
                });
            }
        })
    }

    static downSystem(){
        Swal.fire({
            title: 'Please enter a Password.',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            allowOutsideClick: false,
            preConfirm: (result) => {
                if(result == ""){
                    Swal.showValidationMessage(`Password is Empty"`)
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                _showLoading(); 
                _method('/system-down/' + result.value, 'GET', true, '').then((response) => {
                  
                    if(response.response.success){
                        Swal.fire({
                            html: `Please click button below to access website.`,
                            confirmButtonText: 'Access Page',
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.href = response.response.data.url;
                            }
                        })
                        return false;
                    }
                    
                    
                    _showMessage('warning', response.response.outMessage) 

                }).catch(error => { 


                });
            }
        })
    }

    static upSystem(){
        Swal.fire({
            title: 'Please enter a Password.',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            allowOutsideClick: false,
            preConfirm: (result) => {
                if(result == ""){
                    Swal.showValidationMessage(`Password is Empty"`)
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                _showLoading(); 
                _method('/system-up/' + result.value, 'GET', true, '').then((response) => {
                  
                    if(response.response.success){
                        location.reload();
                        return false;
                    }
                    
                    _showMessage('warning', response.response.outMessage) 

                }).catch(error => { 


                });
            }
        })
    }

    static accountManager(){
        _showLoading()
        _method('/get-account-manager', 'GET', true, '').then((response) => {
            _hideLoading()

            if (response.response.success) {
                let $content = "";
                $content = `<div class="col-lg-12">
                                <form id="account-manager-form">
                                    <div class="col-lg-12 row m-0 p-0 g-2 text-start">
                                        <div class="col-lg-4">
                                            <label>First Name </label>  
                                            <input type="text" class="form-control" name="account_manager_fname" value="${response.response.data.account_manager_fname}">         
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Middle Name </label>  
                                            <input type="text" class="form-control" name="account_manager_mname" value="${response.response.data.account_manager_mname}">         
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Last Name </label>  
                                            <input type="text" class="form-control" name="account_manager_lname" value="${response.response.data.account_manager_lname}">         
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Mobile Number </label>  
                                            
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">+63</span>
                                                <input type="text" name="account_manager_mobileno" class="form-control" value="${response.response.data.account_manager_mobileno}" maxlength="10">
                                            </div>    
                                        </div>
                                        <div class="col-lg-8">
                                            <label>Email Address </label>  
                                            <input type="text" class="form-control" name="account_manager_emailaddress" value="${response.response.data.account_manager_emailaddress}" readonly>         
                                        </div>

                                        <div class="col-lg-12 mt-3 mb-1">
                                            <label class="fw-bold">Change Password</label>  
                                        </div>
                                        <div class="col-lg-12 row m-0 p-2 bg-light border rounded">
                                            <div class="col-lg-6 px-1">
                                                <label>Current Password</label>
                                                <div class="position-relative">
                                                    <input type="password" class="form-control" name="password_current" id="password_current">
                                                    
                                                    <a class="z-index-99 h-75 text-secondary cursor-pointer position-absolute end-0 bottom-0 me-1">
                                                        <i toggle="#password_current" class="fa fa-eye-slash eye-password toggle-password"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 px-1"></div>
                                            <div class="col-lg-6 px-1">
                                                <label>New Password</label>
                                                <div class="position-relative">
                                                    <input type="password" class="form-control" name="password" id="password">
                                                    
                                                    <a class="z-index-99 h-75 text-secondary cursor-pointer position-absolute end-0 bottom-0 me-1">
                                                        <i toggle="#password" class="fa fa-eye-slash eye-password toggle-password"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 px-1">
                                                <label>Confirm Password</label>
                                                <div class="position-relative">
                                                    <input type="password" class="form-control" name="confirm_password" id="confirm_password">
                                                    
                                                    <a class="z-index-99 h-75 text-secondary cursor-pointer position-absolute end-0 bottom-0 me-1">
                                                        <i toggle="#confirm_password" class="fa fa-eye-slash eye-password toggle-password"></i>
                                                    </a>
                                                </div>
                                            </div>

                                            ${$("#password-checker-content").html()}
                                        </div>
                                    </div>
                                </form>
                            </div>`;
                
                let $footer = "";
                $footer  =  `<div class="col-lg-12 text-end">
                                <button class="btn btn-color-secondary mx-1" id="swal_save">Save</button>
                                <button class="btn btn-light mx-1" id="swal_cancel">Cancel</button>
                            </div>`;

                Swal.fire({
                    title: 'Account Manager',
                    html: $content,
                    footer: $footer,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: '800px',
                    didOpen: function() {

                        _toggle_password();
                        _password_checker();

                        $('[name=account_manager_mobileno]').keypress(_numbersOnly);
                        
                        $("#swal_save").off().on('click', function(){
                            
                            $(this).prop('disabled', true)
                            $(this).html('<i class="fa fa-spinner fa-spin"></i> Please wait...');

                            const   fData = new FormData($('#account-manager-form')[0]);
                            const   fDataFinal = _formDataToJSON(fData);

                            _method('/save-account-manager', 'POST', true, fDataFinal).then((response) => {
                                
                                $(this).prop('disabled', false)
                                $(this).html('Save');

                                if (response.response.success) {
                                    /* if (response.response.if_password_changed) {
                                        Swal.fire({
                                            html: `Your Password was changed successfully. Please click on the "Continue" button`,
                                            icon: 'info',
                                            focusConfirm: true,
                                            allowOutsideClick: false,
                                            confirmButtonText: 'Continue',
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                location.reload();
                                            }
                                        })
                                        return false;
                                    }
                                    $("#header-account-name").html(response.response.acctName)
                                    _showMessage("success", response.response.outMessage); */
                                    location.reload();
                                    return false;
                                }

                                Swal.showValidationMessage(response.response.outMessage)

                            }).catch(error => {
                                $(this).prop('disabled', false)
                                $(this).html('Save');
                            });
                        });

                        $("#swal_cancel").off().on('click', function(){
                            Swal.fire({showConfirmButton: false}).close();
                        });
                        
                    }
                })
                
                return false;
            }

            _showMessage('warning', response.response.outMessage) 

        }).catch(error => {

        });

    }

    static user_payhistory(){
        _showLoading();
        _method('/get-user-payment-history', 'GET', true, '').then((response) => {
            _hideLoading();
            if(response.response.success){
                
                let html = `<div class="col-lg-12 text-start">
                                <div class="table-responsive">
                            
                                    <table class="table table-striped w-100 text-nowrap" id="user-payment-history">
                                        <thead class="thead-light text-center align-middle text-color-primary fw-bold">
                                            <tr>
                                                <th>TRANSACTION <br> DATE & TIME</th>
                                                <th>TRANSACTION <br> TYPE</th>
                                                <th>STATUS</th>
                                                <th>PAYMENT <br> CHANNEL</th>
                                                <th>PAYMENT <br>REFERENCE NO.</th>
                                                <th>TAX <br>AMOUNT</th>
                                                <th>CONVENIENCE <br>FEE</th>
                                                <th>TOTAL <br>AMOUNT</th>
                                            </tr>
                                        </thead>
                                        <tbody class="align-middle">
                                        </tbody>
                                    </table>
                                </div>
                            </div>`;
                
                let footer = `<div class="col-lg-12 text-end">
                                    <button class="btn btn-light mx-1" id="cancel-user-payment-history">Close</button>
                                </div>`;

                Swal.fire({
                    title: "Payment Transaction",
                    html: html,
                    footer: footer,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: (parseInt($('body').innerWidth()) - (parseInt($('body').innerWidth()) >= 1024 ? 400 : 0)).toString() + 'px',
                    didOpen: function() {
                        
                        if($.fn.DataTable != undefined){
                            let tbl_userpayhistory = $('#user-payment-history').DataTable({
                                'columns': [
                                    {"data": 'date_time'},
                                    {"data": 'type_desc'},
                                    {"data": 'status'},
                                    {"data": 'pay_desc'},
                                    {"data": 'control_no'},
                                    {"data": 'amount'},
                                    {"data": 'conv'},
                                    {"data": 'total_amt'},
                                ],
                                'columnDefs': [
                                    {
                                        'targets': [0,4],
                                        'className': 'text-center',
                                    },
                                    {
                                        'targets': [2],
                                        'className': 'text-center fw-bold',
                                    },
                                    {
                                        'targets': [5,6,7],
                                        'className': 'text-end fw-bold bg-primary-10',
                                    },
                                ],
                                'createdRow': function(row, data, dataIndex) {

                                },
                                'rowId'         : 'prcid',
                                'bLengthChange' : true,
                                'searching'     : true,
                                'paging'        : true,
                                'bInfo'         : true,
                                'ordering'      : false,
                                'order'         : [[1, 'asc']],
                            });
                            

                            tbl_userpayhistory.rows().clear().draw();
                            tbl_userpayhistory.rows.add(response.response.data.user_payment_history).draw();
                            setTimeout(function(){ tbl_userpayhistory.columns.adjust().draw(); }, 500);
                        }
                        
                        $("#cancel-user-payment-history").off().on('click', function(){
                            Swal.fire({showConfirmButton: false}).close();
                        });
                    }
                })
                

                
                return false;
            }   
            
            _showMessage('warning', response.response.outMessage) 

        }).catch(error => { 
        
        });
    }
    
    static downloadable_forms(){
        _showLoading();
        
        _method('/get-downloadable-forms-file', 'GET', true, '').then((response) => {
            _hideLoading();
            if(response.response.success){

                let html = `<div class="col-lg-12 text-start">
                                <div class="table-responsive">
                            
                                    <table class="table table-striped w-100 text-nowrap" id="downloadable-forms-tbl">
                                        <thead class="thead-light text-center align-middle text-color-primary fw-bold">
                                            <tr>
                                                <th>FILE</th>
                                                <th>ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody class="align-middle">`;
                                        
                                        $.each(response.response.data.downloadable_forms_files, function(keys, records){
                                            html += `<tr>
                                                <td>
                                                    <label>${records.title}</label> 
                                                </td>
                                                <td class="text-center">
                                                    <a class="btn btn-primary ms-2" download="${records.type}.${records.ext}" href="${records.file}" title="Download"><i class="fa fa-download"></i></a>
                                                </td>
                                            </tr>`;
                                        })
                                html += `</tbody>
                                    </table>
                                </div>
                            </div>`;
                
                let footer = `<div class="col-lg-12 text-end">
                                    <button class="btn btn-light mx-1" id="downloadable-forms-cancel">Close</button>
                                </div>`;

                Swal.fire({
                    title: 'Downloadable Forms',
                    html: html,
                    footer: footer,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: '800px',
                    didOpen: function() {

                        $("#downloadable-forms-cancel").off().off().on('click', function(){
                            Swal.fire({showConfirmButton: false}).close();
                        });
                    }
                })
                      
                return false;
            }   
            
            _showMessage('warning', response.response.outMessage) 

        }).catch(error => { 
        
        }); 
    }

    static check_cs_p(){
        _method('/cs-p', 'GET', false, '').then((response) => {
            if(response.response.expired){
                
                Swal.fire({
                    html: "Session Expired.",
                    icon: 'info',
                    focusConfirm: true,
                    allowOutsideClick: false,
                    confirmButtonText: 'LOG-OUT',
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                })

            }
        }).catch(error => { 
            //location.reload();    
        });  
    }

    

    static check_notif_popup(_data, _index){
        if(_data[_index].notif_read == false){
            $(".notif_indicator_message").removeClass('active')
            setTimeout(() => {
                $(".notif_indicator_message").html(_data[_index].notif_message + "<br>" + "Please click the go button to update the list.")
                $(".notif_indicator_message").addClass('active')
            }, 1000);
        }
    }
    
    static check_notif(){
        _method('/check-notification', 'GET', false, '').then((response) => {
            
            if(response.response.success){
                if (response.response.data.notif_indicator_count < 1) {
                    $(".notif_indicator").addClass('d-none');
                }else{
                    
                    $(".notif_indicator").removeClass('d-none');
                }
                $(".notif_indicator").html(response.response.data.notif_indicator_count)

                let notifData = response.response.data.notification;

                if(notifData.length > 0){
                    if(notifData.length == 1){
                        _globalButtons.check_notif_popup(notifData, 0) 
                            
                        setTimeout(() => {
                            $(".notif_indicator_message").removeClass('active')
                        }, 8000);
                    }
                    if(notifData.length == 2){
                        _globalButtons.check_notif_popup(notifData, 1) 
                            
                        setTimeout(() => { 
                            _globalButtons.check_notif_popup(notifData, 0) 
                                
                            setTimeout(() => {
                                $(".notif_indicator_message").removeClass('active')
                            }, 8000);
                        }, 8000);
                    }
                    if(notifData.length == 3){
                        _globalButtons.check_notif_popup(notifData, 2) 
                        
                        setTimeout(() => { 
                            _globalButtons.check_notif_popup(notifData, 1) 
                            
                            setTimeout(() => { 
                                _globalButtons.check_notif_popup(notifData, 0) 
                                    
                                setTimeout(() => {
                                    $(".notif_indicator_message").removeClass('active')
                                }, 8000);
                            }, 8000);
                        }, 8000);
                    }
                    if(notifData.length == 4){
                        _globalButtons.check_notif_popup(notifData, 3) 
                        
                        setTimeout(() => { 
                            _globalButtons.check_notif_popup(notifData, 2) 
                            
                            setTimeout(() => { 
                                _globalButtons.check_notif_popup(notifData, 1) 
                                
                                setTimeout(() => { 
                                    _globalButtons.check_notif_popup(notifData, 0) 
                                        
                                    setTimeout(() => {
                                        $(".notif_indicator_message").removeClass('active')
                                    }, 8000);
                                }, 8000);
                            }, 8000);
                        }, 8000);
                    }
                    if(notifData.length >= 5){
                        _globalButtons.check_notif_popup(notifData, 4)

                        setTimeout(() => { 
                            _globalButtons.check_notif_popup(notifData, 3) 
                            
                            setTimeout(() => { 
                                _globalButtons.check_notif_popup(notifData, 2) 
                                
                                setTimeout(() => { 
                                    _globalButtons.check_notif_popup(notifData, 1) 
                                    
                                    setTimeout(() => { 
                                        _globalButtons.check_notif_popup(notifData, 0) 
                                            
                                        setTimeout(() => {
                                            $(".notif_indicator_message").removeClass('active')
                                        }, 8000);
                                    }, 8000);
                                }, 8000);
                            }, 8000);
                        }, 8000);
                    }
                }
                return false;
            }

        }).catch(error => { 


        });
    }

    static get_notif(){
        _showLoading(); 
        _method('/get-notification', 'GET', true, '').then((response) => {
            _hideLoading()
            if(response.response.success){
                
                let html = `<div class="col-lg-12 text-start">
                                <div class="table-responsive">
                            
                                    <table class="table table-striped w-100 text-nowrap" id="user-notification">
                                        <thead class="thead-light text-center align-middle text-color-primary fw-bold">
                                            <tr>
                                                <th>DATE & TIME</th>
                                                <th>MESSAGE</th>
                                            </tr>
                                        </thead>
                                        <tbody class="align-middle">
                                        </tbody>
                                    </table>
                                </div>
                            </div>`;
                
                let footer = `<div class="col-lg-12 text-end">
                                    <button class="btn btn-light mx-1" id="cancel-user-notification">Close</button>
                                </div>`;

                Swal.fire({
                    title: "Notification",
                    html: html,
                    footer: footer,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: '800px',
                    didOpen: function() {
                        
                        if($.fn.DataTable != undefined){
                            let tbl_notification = $('#user-notification').DataTable({
                                'columns': [
                                    {"data": 'date_time'},
                                    {"data": 'notif_message'},
                                ],
                                'columnDefs': [
                                    {
                                        'targets': [0],
                                        'className': 'text-center',
                                    },
                                    {
                                        'targets': [1],
                                        'className': 'text-start',
                                    },
                                ],
                                'createdRow': function(row, data, dataIndex) {
                                    if(data.notif_read == false){
                                        $(row).find('td').addClass('bg-primary-10');
                                    }
                                },
                                'rowId'         : 'prcid',
                                'bLengthChange' : true,
                                'searching'     : true,
                                'paging'        : true,
                                'bInfo'         : true,
                                'ordering'      : false,
                                'order'         : [[0, 'asc']],
                            });
                            

                            tbl_notification.rows().clear().draw();
                            tbl_notification.rows.add(response.response.data.notification).draw();
                            setTimeout(function(){ tbl_notification.columns.adjust().draw(); }, 500);

                            $(".notif_indicator").html(0)
                            $(".notif_indicator").addClass('d-none');
                        }
                        
                        $("#cancel-user-notification").off().on('click', function(){
                            Swal.fire({showConfirmButton: false}).close();
                        });
                    }
                })

                
                return false;
            }
            
            _showMessage('warning', response.response.outMessage) 

        }).catch(error => { 


        });
    }

    static faq(){
        let html = `<div class="col-lg-12 text-start">
                    <div class="px-1">
                        ${data_faq}
                    </div>
                </div>`;

        Swal.fire({
            title: '',
            html: html,
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: 'Close',
            showConfirmButton: false,
            width: '750px',
        })
    }
}

const _convertStringToInt = (value) => {
    const result = value.replace(/[^0-9]/g, '');
    return parseInt((result == "" ? "0" : result));
}
const _convertStringToDec = (value) => {
    const result = value.replace(/[^0-9.]/g, '');
    return parseFloat(result);
}

const _numbersOnly = (event) => {
    let key = window.event ? event.keyCode : event.which;
  
    if (key === 8 || key === 46) {
        return true;
    }else if(key === 45){  /* - */
        return false;   
    }else if(key === 32){  /* space */
        return false;
    }else if(event.shiftKey  && key === 40){  /* ( */
        return false;
    }else if(event.shiftKey  && key === 41){ /* ) */
        return false;
    } else if ( key < 48 || key > 57 ) {
        return false;
    } else {
        return true;
    }
}


const _thousandsFormat = (param) => {
    let thousands = (param == "" || isNaN(param) || param == undefined ? "0.00" : param).toString().split(".");
    thousands[0] = parseFloat(thousands[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return thousands.join(".");
}

const _thousandsFormat3Dec = (param) => {
    let thousands = (param == "" || isNaN(param) || param == undefined ? "0.000" : param).toString().split(".");
    thousands[0] = parseFloat(thousands[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return thousands.join(".");
}

class _currencyFormat {
    static formatNum(num) {
        return num.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
    }


    static convertNum(input, KorB) {
        let input_val = input.val();
        if (input_val === "") { return; }
        let original_len = input_val.length;
        let caret_pos = input.prop("selectionStart");
    
        if (input_val.indexOf(".") >= 0) {

            let decimal_pos = input_val.indexOf(".");
            let left_side = input_val.substring(0, decimal_pos);
            let right_side = input_val.substring(decimal_pos);
            left_side = _currencyFormat.formatNum(left_side);
            right_side = _currencyFormat.formatNum(right_side);

            if (KorB === "blur") {
                right_side += "00";
            }
            right_side = right_side.substring(0, 2);

            input_val = left_side + "." + right_side;

        } else {
            input_val = _currencyFormat.formatNum(input_val);
            input_val = input_val;
            
            if (KorB === "blur") {
                input_val += ".00";
            }
        }
        
        input.val(input_val);
        
        let updated_len = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input[0].setSelectionRange(caret_pos, caret_pos);

    }
}


const _generateRandomString = () => {
    
    let rand1 = (Math.random() + 1).toString(36).substring(7);
    let rand2 = (Math.random() + 1).toString(36).substring(7);
    let rand3 = (Math.random() + 1).toString(36).substring(7);
    let rand4 = (Math.random() + 1).toString(36).substring(7);
    let rand5 = (Math.random() + 1).toString(36).substring(7);

    return rand1+rand2+rand3+rand4+rand5;
}

const _pdfToCanvasRender = (_pdf, _parentLink, _parentId, _pageIndex) => {

    let canvas = $('<canvas/>')[0];
    const ctx = canvas.getContext('2d');

    const myState = {
        pdf: null,
        currentPage: _pageIndex,
        zoom: 1
    }
    myState.pdf = _pdf;
    myState.pdf.getPage(myState.currentPage).then((page) => {

        /* page.getTextContent().then(data => {
            console.log(data);
        }); */

        const viewport = page.getViewport(myState.zoom);
        const resolution =  3;  /* 5 high quality */
        const className = 'show_popup_indicator';
        canvas.className = className;
        canvas.width = resolution * viewport.width;
        canvas.height = resolution * viewport.height;

        page.render({
            canvasContext: ctx,
            viewport: viewport,
            transform: [resolution, 0, 0, resolution, 0, 0]
        })
        .promise.then(function(){
            $("#" + _parentId).parent().removeClass('d-none');
            $("#" + _parentId).append(canvas);
            $("." + className).css("zoom", "50%");
            $("." + className).addClass("bg-dark p-2 mb-2 mx-1");

            //generate page to total page
            if(_pageIndex != _pdf.numPages){
                /* $('#swal2-html-container label').html("<label class='fs-4'>Page <b>" + _pageIndex + "</b> of " + _pdf.numPages + "</label>"); */
                _pageIndex = _pageIndex + 1;
                _pdfToCanvasRender(_pdf, _parentLink, _parentId, _pageIndex);
            }else{
                /* $('#swal2-html-container label').html("<label class='fs-4'>Page <b>" + _pageIndex + "</b> of " + _pdf.numPages + "</label>");
                setTimeout(function() {
                    _hideLoading();
                }, 1000); */
            }
        });

    });
}
const _pdfToCanvas = (data) => {
    $.each(data, function (key, value) {
        //link and id set to blade
        const parentLink = value['link'];
        const parentId = value['id'];
        const pageIndex = 1;

        //available canvas dont load again
        if($("#" + parentId).children().length != 0){
            return false;
        }

        /* _showLoading(); */

        //blank parent of canvas
        $("#" + parentId).html('');
        pdfjsLib.getDocument(parentLink).promise.then((pdf) => {
            //generate page to total page (initial first page)
            _pdfToCanvasRender(pdf, parentLink, parentId, pageIndex);
        }).catch(function(error){
            /* NO CONVERT DIRECT TO IMG  */
            $("#" + parentId).html(`<img class="show_popup_indicator" width="100%" src="${parentLink}">`);
            
            /* _hideLoading(); */
        });
    });

}
const _zoom_in = (_indicator) => {
    if($(_indicator).parent('div').children("img").length > 0){
        $(_indicator).attr('width', (parseInt($(_indicator).attr('width').replace("%","")) + 10).toString() + "%")
    }else{
        /* CANVAS */
        let zoomIn = (parseInt($(_indicator).attr('style').replace("zoom:","").replace("%","").trim()));
        $(_indicator).css("zoom", (zoomIn + 10).toString() + "%");
    }
}
const _zoom_out = (_indicator) => {
    
    if($(_indicator).parent('div').children("img").length > 0){
        let zoomOut = parseInt($(_indicator).attr('width').replace("%",""));
        if(zoomOut == 20){
            zoomOut = 20;
        }else{
            zoomOut = zoomOut - 10;
        }
        $(_indicator).attr('width', zoomOut.toString() + "%")
    }else{
        /* CANVAS */
        let zoomOut = (parseInt($(_indicator).attr('style').replace("zoom:","").replace("%","").trim()));
        if(zoomOut == 20){
            zoomOut = 20;
        }else{
            zoomOut = zoomOut - 10;
        }
        $(_indicator).css("zoom", zoomOut.toString() + "%");
    }
} 
const _zoom_reset = (_indicator) => {
    if($(_indicator).parent('div').children("img").length > 0){
        $(_indicator).attr('width', '100%')
    }else{
        /* CANVAS */
        $(_indicator).css("zoom", "50%");
    }
    
}
const _show_popup_url = (url) => {

    let urlData  = `<div class="col-lg-12 p-0 position-relative">
                        <div class="col-lg-12 p-0" style="overflow:auto;height:${(window.innerHeight - 250).toString()}px;display:grid;align-items:center;justify-content:center;" id="show_popup_indicator_content">
                            
                        </div>
                    </div>`;
    let footer = `
        <div class="col-lg-12 row m-0 g-1">
            <div class="col-lg-6 text-md-start text-center">
                <button class="btn btn-primary" title="Zoom In" onclick="_zoom_in('.show_popup_indicator')">
                    <i class="fa-solid fa-magnifying-glass-plus"></i>
                </button>
                <button class="btn btn-primary" title="Zoom Out" onclick="_zoom_out('.show_popup_indicator')">
                    <i class="fa-solid fa-magnifying-glass-minus"></i>
                </button>
                <button class="btn btn-color-secondary" title="Zoom Reset" onclick="_zoom_reset('.show_popup_indicator')">
                    <i class="fa-solid fa-arrows-rotate"></i>
                </button>
            </div>
            <div class="col-lg-6 text-md-end text-center">
                <button class="btn btn-primary" id="open-show-popup-url">Open to another window</button>
                <button class="btn btn-light" id="cancel-show-popup-url">Close</button>
            </div>
        </div>
    `;
    Swal.fire({
        html:  urlData,
        footer: footer,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        width: (parseInt($('body').innerWidth()) - (parseInt($('body').innerWidth()) >= 1024 ? 250 : 0)).toString() + 'px', 
        didOpen: () => {
            _pdfToCanvas([{"link" : url, "id" : "show_popup_indicator_content"}]);

            $("#open-show-popup-url").off().on('click', function(){
                window.open(`${url}`);
            });
            $("#cancel-show-popup-url").off().on('click', function(){
                Swal.fire({showConfirmButton: false}).close();
            });
        },
    })
}

window._method              = _method;
window._formGetDataNotIsset = _formGetDataNotIsset;
window._formDataToJSON      = _formDataToJSON;
window._showMessage         = _showMessage;
window._showLoading         = _showLoading;
window._hideLoading         = _hideLoading;
window._globalButtons       = _globalButtons;

window._convertStringToInt  = _convertStringToInt;
window._convertStringToDec  = _convertStringToDec;
window._numbersOnly         = _numbersOnly;
window._thousandsFormat     = _thousandsFormat;
window._thousandsFormat3Dec = _thousandsFormat3Dec;
window._currencyFormat      = _currencyFormat;
window._generateRandomString = _generateRandomString;
window._pdfToCanvasRender    = _pdfToCanvasRender;
window._pdfToCanvas          = _pdfToCanvas;
window._zoom_in              = _zoom_in;
window._zoom_out             = _zoom_out;
window._zoom_reset           = _zoom_reset;
window._show_popup_url       = _show_popup_url;

$(() => {

    const consoleStyle = 'background-color: #000; color: #fff; border: 3px solid yellow; font-size: 5rem; padding: 20px; text-align: center;';
    console.log("%c" + $('head title').html(), consoleStyle);

    $("input").attr('autocomplete', 'off');
    $("img").attr('draggable', 'false');

    window.onscroll = () => {
        if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
            $(".btn-scroll-top").removeClass('d-none');
        } else {
            $(".btn-scroll-top").addClass('d-none');
        }
    };
    $(".btn-scroll-top").off().on('click', () => {
        window.scroll({top: 0, behavior: "smooth"});
    });

    $(':radio[readonly], :checkbox[readonly]').off().on('click', function(e) {
        return false;
    });

    $(document).on('keyup keypress', '.modal.show form input', function(e) {
        if(e.which == 13) {
            e.preventDefault();
            return false;
        }
    });

    $('.numbersOnly, .thousandsFormat, .thousandsFormat3Dec').keypress(_numbersOnly);
    $(".thousandsFormat, .thousandsFormat3Dec").on('focusin', function(e) {
        $(this).val($(this).val().replace(/[^\d+(\.\d+)*$]/g, ""));
    })
    $(".thousandsFormat").on('focusout', function(e) {
        $(this).val(_thousandsFormat(parseFloat($(this).val().replace(/[^\d+(\.\d+)*$]/g, "")).toFixed(2)));
    })
    $(".thousandsFormat3Dec").on('focusout', function(e) {
        $(this).val(_thousandsFormat3Dec(parseFloat($(this).val().replace(/[^\d+(\.\d+)*$]/g, "")).toFixed(3)));
    })

    $("input[data-type='currency']").on({
        keyup: function() {
            _currencyFormat.convertNum($(this), "keyup");
        },
        blur: function() { 
            _currencyFormat.convertNum($(this), "blur");
        }
    });

    if($.fn.datepicker != undefined){
        $(".yearpicker").datepicker({
            changeYear: true,
            dateFormat: 'yy',
            yearRange: "-150:+0",
            showButtonPanel: true,
            onClose: function(dateText, inst) {$(this).val($("#ui-datepicker-div .ui-datepicker-year :selected").val())}
        }).on('focus', function () {
            $(".ui-datepicker-month, .ui-datepicker-calendar, .ui-datepicker-prev, .ui-datepicker-next").hide();
            $(".ui-datepicker-year").addClass('form-select w-100 text-center');
        });

        $(".datepicker").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-150:+0",
            maxDate: 0,
            
            showButtonPanel: true,
            closeText: 'Clear',
            onClose: function (dateText, inst) {
                if ($(/* window.event.srcElement ||  */window.event.target).hasClass('ui-datepicker-close')) {
                    document.getElementById(this.id).value = '';
                }
            }
        });

        $(".datepicker-current").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-0:+0",
            
            showButtonPanel: true,
            closeText: 'Clear',
            onClose: function (dateText, inst) {
                if ($(/* window.event.srcElement ||  */window.event.target).hasClass('ui-datepicker-close')) {
                    document.getElementById(this.id).value = '';
                }
            }
        });

        $(".datepicker-plus-20y").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-150:+20",
            
            showButtonPanel: true,
            closeText: 'Clear',
            onClose: function (dateText, inst) {
                if ($(/* window.event.srcElement ||  */window.event.target).hasClass('ui-datepicker-close')) {
                    document.getElementById(this.id).value = '';
                }
            }
        });

        $(".datepicker-plus-150y").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-150:+150",
            
            showButtonPanel: true,
            closeText: 'Clear',
            onClose: function (dateText, inst) {
                if ($(/* window.event.srcElement ||  */window.event.target).hasClass('ui-datepicker-close')) {
                    document.getElementById(this.id).value = '';
                }
            }
        });
    }

    $('.sidebarCollapse-btn').off().on('click', () => {
        
        if($.fn.DataTable != undefined) setTimeout(function(){ $('dataTable').DataTable().columns.adjust().draw(); }, 400);

        $('.sidebarCollapse-btn').toggleClass('active');
        $('.sidebar').toggleClass('active');
        $('.content').toggleClass('active');

        if($('.sidebar').hasClass('active')){
            $('.sidebar ul li a span').parent('div').addClass('d-none');
            $('.sidebar ul li a i').parent('div').addClass('col-lg-12');

            $('.sidebar ul li').children('div').removeClass('show');
        }else{
            $('.sidebar ul li a span').parent('div').removeClass('d-none');
            $('.sidebar ul li a i').parent('div').removeClass('col-lg-12');
        }

    });

    $(document).on('click', "a.collapse-items", function(e) {
        $(this).find('i').toggleClass('fa-caret-down fa-caret-up')
    });

    $(document).on('click', ".collapse-sidebar-list", function(e) {
        if($('.sidebar').hasClass('active')){
            let id = $(this).attr('data-bs-target');
            $(id).addClass('d-none');
            setTimeout(function(){
                $('.sidebarCollapse-btn').trigger('click');
                $(id).removeClass('d-none');
            }, 400);
        }
    });


});
